export const WECHAT_GRANT = 'WECHAT_GRANT';
export const WECHAT_JSSDK = 'WECHAT_JSSDK';



// WEBPACK FOOTER //
// ./src/store/wechat/types.js